export enum REVIEW_TABS {
  GOOGLE = 'GOOGLE REVIEWS',
  YELP = 'YELP REVIEWS',
  OTHER_REVIEWS = 'OTHER REVIEWS',
}
